import { Box, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PaymentsIcon from '@mui/icons-material/Payments';
import { RowAction } from '../../../../../components/row-action';
import { ILiquidationResponse } from '../../../../../model/sge/liquidation/response/liquidation-response';
import { IPaymentResponse } from '../../../../../model/sge/payment/response/payment-response';
import { formatDate } from '../../../../../utils/date';
import { formatCurrency } from '../../../../../utils/format';
import { AmendmentDetailController } from '../context/amendment-detail-controller';
import { sumAmounts } from './amendment-detail-form-utils';
import { EmptyRow, NestedPanelHeader, dashIfEmpty } from './detail-parts';
import { InlineProgress } from './progress-stat';

export function PaymentsPanel({ liquidation, payments, ctrl }: { liquidation: ILiquidationResponse; payments: IPaymentResponse[]; ctrl: AmendmentDetailController }) {
    return (
        <Box sx={{ pl: { xs: 2, sm: 5 }, pr: 2, pb: 2, pt: 0.5 }}>
            <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden', borderLeft: '3px solid', borderLeftColor: 'success.main' }}>
                <NestedPanelHeader
                    icon={<PaymentsIcon fontSize="small" color="success" />}
                    title={`Pagamentos (${payments.length})`}
                    action={<Button size="small" variant="outlined" color="success" startIcon={<AddIcon />} onClick={() => ctrl.openPaymentDrawer(liquidation)}>Novo Pagamento</Button>}
                    progress={<InlineProgress current={sumAmounts(payments, (p) => p.paidAmount)} total={liquidation.liquidatedAmount || 0} color="success" />}
                />
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Nº Ordem</TableCell>
                            <TableCell>Data</TableCell>
                            <TableCell align="right">Valor Pago</TableCell>
                            <TableCell align="right">Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payments.length === 0 && <EmptyRow colSpan={4} message="Nenhum pagamento registrado" />}
                        {payments.map((payment) => (
                            <TableRow key={payment.id} hover>
                                <TableCell>{dashIfEmpty(payment.paymentOrderNumber)}</TableCell>
                                <TableCell>{dashIfEmpty(formatDate(payment.paymentDate))}</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 600 }}>{formatCurrency(payment.paidAmount)}</TableCell>
                                <TableCell align="right">
                                    <Box sx={{ display: 'inline-flex' }}>
                                        <RowAction title="Editar" onClick={() => ctrl.openPaymentDrawer(liquidation, payment)}><EditIcon fontSize="small" /></RowAction>
                                        <RowAction title="Excluir" color="error" onClick={() => ctrl.deletePayment(liquidation, payment)}><DeleteIcon fontSize="small" /></RowAction>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Box>
    );
}
